module.exports = __webpack_public_path__ + "img/backgroundImg.47f08441.jpg";